import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import attachmentsActionCreators from '../../../store/attachments/action-creators';
import AttachmentForm from './AttachmentForm';

const AttachmentAdd = (props) => {
  // ----------------------
  // Render
  // ----------------------

  return (
    <Fragment>
      <AttachmentForm
        onUpload={formData => props.createAttachment(formData)}
      />
    </Fragment>
  );
};

// ----------------------
// Redux Mappings
// ----------------------

const mapDispatchToProps = (dispatch) => {
  return {
    createAttachment: (formData) => {
      dispatch(attachmentsActionCreators.createAttachment(formData));
    },
  };
};

export default connect(null, mapDispatchToProps)(AttachmentAdd);
